import { handleError, handleResponse } from "@/utils/functions.js";

export default (axios) => ({
  login(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("login/", payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
